/*
 * élome — Mobile bottom-nav wiring.
 *
 * The fixed bottom nav (layout/theme.liquid) replaces the in-header menu/search
 * icons on mobile. Its Menu and Search buttons proxy to Dawn's existing drawer
 * triggers by programmatically clicking the header's <summary> elements, so all
 * of Dawn's drawer/modal logic (focus trap, overflow lock, close handlers) runs
 * unchanged. Account + Bag are plain links and need no JS. Mobile only.
 */
(function () {
  function init() {
    if (window.innerWidth > 749) return;

    var menuBtn = document.getElementById('elome-bottom-menu');
    var searchBtn = document.getElementById('elome-bottom-search');

    // Open a header drawer/modal by proxying its <summary>. The trigger click is
    // deferred to a fresh task: Dawn's search details-modal attaches a
    // document-level outside-click listener the moment it opens, so if we click
    // the summary synchronously the *current* bottom-nav click keeps bubbling to
    // <body>, the modal reads it as an outside click, and closes itself. Letting
    // this click finish first avoids that race. (The menu-drawer has no such
    // listener, but deferring is harmless there too.)
    function openVia(selector, event) {
      event.preventDefault();
      event.stopPropagation();
      var trigger = document.querySelector(selector);
      if (!trigger) return;
      var isMenu = event.currentTarget === menuBtn;
      window.setTimeout(function () {
        var wasOpen = trigger.closest('details').open;
        trigger.click();
        if (isMenu && wasOpen) menuBtn.focus();
      }, 0);
    }

    if (menuBtn) {
      var menuDetails = document.querySelector('header-drawer details');
      if (menuDetails) {
        var panel = menuDetails.querySelector('.menu-drawer');
        if (panel && panel.id) menuBtn.setAttribute('aria-controls', panel.id);
        menuBtn.setAttribute('aria-expanded', String(menuDetails.open));
        menuDetails.addEventListener('toggle', function () {
          menuBtn.setAttribute('aria-expanded', String(menuDetails.open));
          if (!menuDetails.open || window.innerWidth > 749) return;
          var attempts = 0;
          window.requestAnimationFrame(function focusWhenVisible() {
            if (!menuDetails.open || menuDetails.querySelector('summary').getAttribute('aria-expanded') !== 'true') return;
            if (!menuDetails.classList.contains('menu-opening') || getComputedStyle(panel).visibility !== 'visible') {
              if (++attempts < 30) window.requestAnimationFrame(focusWhenVisible);
              return;
            }
            var first = panel && panel.querySelector('a[href], button:not([disabled]), summary');
            if (first && typeof trapFocus === 'function') trapFocus(panel, first);
          });
        });
      }
      menuBtn.addEventListener('click', function (event) {
        openVia('.header__icon--menu.header__icon--summary', event);
      });
      document.addEventListener('keyup', function (event) {
        if (event.key !== 'Escape' || window.innerWidth > 749) return;
        var drawer = document.querySelector('header-drawer');
        var details = drawer && drawer.querySelector('details[open]');
        if (!details || (!drawer.contains(event.target) && event.target !== menuBtn)) return;
        var nested = event.target.closest('details[open]');
        if (nested && nested !== details) return;
        if (typeof drawer.closeMenuDrawer !== 'function') return;
        event.preventDefault();
        event.stopPropagation();
        drawer.closeMenuDrawer(event, menuBtn);
        details.querySelector('summary').setAttribute('aria-expanded', 'false');
      }, true);
    }

    if (searchBtn) {
      searchBtn.addEventListener('click', function (event) {
        openVia('.header__icon--search.header__icon--summary', event);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
